/* Northbench geo helpers: address autocomplete (Photon / OpenStreetMap), distance math,
   product feed loader (/collections/<handle>?view=nbgeo) and the saved search location.
   The searched location is kept in sessionStorage only, never in the URL. */
(function () {
  if (window.NBGeo) return;
  var US_BBOX = '-179.2,18.9,-66.9,71.4';
  var KEY = 'nb-near-me';
  var cache = {};

  function hav(a, b, c, d) {
    var R = 6371, r = Math.PI / 180;
    var x = Math.pow(Math.sin(((c - a) * r) / 2), 2) + Math.cos(a * r) * Math.cos(c * r) * Math.pow(Math.sin(((d - b) * r) / 2), 2);
    return 2 * R * Math.asin(Math.sqrt(x)) * 0.621371; // miles
  }

  function load(handles) {
    var k = handles.join(',');
    if (cache[k]) return cache[k];
    cache[k] = Promise.all(handles.map(function (h) {
      var items = [];
      function page(n) {
        return fetch('/collections/' + encodeURIComponent(h) + '?view=nbgeo&page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (t) {
            if (!t) return;
            var j = JSON.parse(t);
            items = items.concat(j.items || []);
            if (n < (j.pages || 1) && n < 20) return page(n + 1);
          })
          .catch(function () {});
      }
      return page(1).then(function () { return { h: h, items: items }; });
    }));
    return cache[k];
  }

  function label(f) {
    var p = f.properties || {};
    var town = p.city || p.town || p.village || p.district || p.county;
    var line1 = [p.housenumber, p.street].filter(Boolean).join(' ');
    var place = [town, p.state, p.postcode].filter(Boolean).join(', ');
    if (!line1 && p.name && p.name !== town) line1 = p.name;
    return {
      main: line1 || place || p.name || '',
      sub: line1 ? place : '',
      place: [town || p.name, p.state].filter(Boolean).join(', ')
    };
  }

  function save(loc) { try { sessionStorage.setItem(KEY, JSON.stringify(loc)); } catch (e) {} }
  function read() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }

  function locate(ok, fail) {
    if (!navigator.geolocation) { fail(); return; }
    navigator.geolocation.getCurrentPosition(
      function (p) { ok({ la: p.coords.latitude, lo: p.coords.longitude, place: 'your location' }); },
      fail,
      { timeout: 10000, maximumAge: 600000 }
    );
  }

  /* Wires an input + listbox into an address autocomplete. onChoose({la, lo, place, text}) */
  function autocomplete(input, wrap, list, onChoose) {
    var feats = [], active = -1, timer = null, ctrl = null;

    function close() {
      wrap.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function render() {
      list.innerHTML = '';
      feats.forEach(function (f, i) {
        var l = label(f);
        var li = document.createElement('li');
        li.id = list.id + '-' + i;
        li.className = 'nbgeo__opt';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        var a = document.createElement('span'); a.className = 'nbgeo__main'; a.textContent = l.main;
        li.appendChild(a);
        if (l.sub) { var b = document.createElement('span'); b.className = 'nbgeo__sub'; b.textContent = l.sub; li.appendChild(b); }
        li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(i); });
        list.appendChild(li);
      });
      if (feats.length) { wrap.hidden = false; input.setAttribute('aria-expanded', 'true'); } else { close(); }
    }

    function setActive(i) {
      var opts = list.children;
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      for (var k = 0; k < opts.length; k++) opts[k].setAttribute('aria-selected', k === active ? 'true' : 'false');
      input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }

    function choose(i) {
      var f = feats[i];
      if (!f) return;
      var l = label(f);
      input.value = [l.main, l.sub].filter(Boolean).join(', ');
      close();
      input.blur();
      onChoose({ la: f.geometry.coordinates[1], lo: f.geometry.coordinates[0], place: l.place || l.main, text: input.value });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 3) { feats = []; close(); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        fetch('https://photon.komoot.io/api/?q=' + encodeURIComponent(q) + '&limit=8&lang=en&bbox=' + US_BBOX, { signal: ctrl.signal })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            feats = (j.features || []).filter(function (f) {
              var p = f.properties || {};
              if (p.countrycode && p.countrycode !== 'US') return false;
              if (p.osm_value === 'bus_stop' || p.osm_key === 'public_transport') return false;
              return true;
            }).slice(0, 5);
            render();
          })
          .catch(function (e) { if (e.name !== 'AbortError') { feats = []; close(); } });
      }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (wrap.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter') { e.preventDefault(); choose(active >= 0 ? active : 0); }
      else if (e.key === 'Escape') { close(); }
    });
    input.addEventListener('blur', function () { setTimeout(close, 120); });
  }

  window.NBGeo = { hav: hav, load: load, label: label, save: save, read: read, locate: locate, autocomplete: autocomplete, PAGE: '/pages/near-me' };
  document.dispatchEvent(new CustomEvent('nbgeo:ready'));
})();
